import script from "./Schemes.vue?vue&type=script&setup=true&lang=js"
export * from "./Schemes.vue?vue&type=script&setup=true&lang=js"

import "./Schemes.vue?vue&type=style&index=0&id=1efe15c6&lang=less&scoped=true"

import exportComponent from "D:\\allcodes\\com\\qlt-v2\\web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8a20d2b94e5a8d2b7a50170f7fabe87d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efe15c6"]])

export default __exports__